import type { ReactElement } from "react";
import { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import { translate } from "app/filters/i18nFilter";
import IsNewOnlyCheckboxContainer from "app/pages/sales-intelligence/modules/advanced-search-filtering/containers/IsNewOnlyCheckbox/IsNewOnlyCheckboxContainer";
import advancedSearchFilteringTrackingService from "app/pages/sales-intelligence/modules/advanced-search-filtering/services/tracking";
import {
    resetSearchText,
    SearchRowContainer,
    selectActiveLeadsType,
    useSearchResultsQuota,
} from "app/pages/sales-intelligence/modules/leads-search";
import SearchQuotaPopover from "app/pages/sales-intelligence/modules/quota/components/SearchQuotaPopover/SearchQuotaPopover";

const TableSearchRowContainer = (): ReactElement => {
    const dispatch = useDispatch();

    const activeLeadsType = useSelector(selectActiveLeadsType);
    const { isQuotaReached, isLoading, fetch: refetchQuota } = useSearchResultsQuota();
    const isRowDisabled = isQuotaReached || isLoading;

    const handleSearchClear = (text: string) => {
        advancedSearchFilteringTrackingService.trackSearchFieldCleared(activeLeadsType, text);
        refetchQuota();
    };

    useEffect(() => {
        if (isQuotaReached) {
            dispatch(resetSearchText());
        }
    }, [isQuotaReached]);

    const row = (
        <SearchRowContainer
            isDisabled={isRowDisabled}
            onSearchClear={handleSearchClear}
        >
            <IsNewOnlyCheckboxContainer isDisabled={isRowDisabled} />
        </SearchRowContainer>
    );

    if (isRowDisabled) {
        return <SearchQuotaPopover content={translate("si.company_search.disabled.tooltip")}>{row}</SearchQuotaPopover>;
    }

    return row;
};

export default TableSearchRowContainer;
